module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "author"
  }, [_vm._v("16")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_c('span', [_vm._v("Ich habe")]), _vm._v(" die Ladung\ngehabt zum"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nFest dieser Welt, und so ist mein Leben"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\ngesegnet. Meine Augen haben gesehn,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nmeine Ohren gehört.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Mein Teil auf diesem Feste war, mein"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nInstrument zu spielen, ich habe alles,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nwas ich konnte, getan.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Nun frag ich, ist endlich die Zeit mir"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\ngekommen, wo ich eintreten darf und"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\ndein Antlitz sehn und dir schweigend"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nbieten meinen Gruß? "), _c('a', {
    attrs: {
      "id": "page21",
      "title": "Wunibald/cal"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2413dca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0017.vue
// module id = 105
// module chunks = 0